import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionDeliveryOption } from '../keys/permissionDelivery.interface';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionDelivery: PermissionOption[] = [
  {
    code: 'P100',
    option: PermissionDeliveryOption.DELIVERY_COMMON_LOGIN,
    permissions: ['domi.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P101',
    option: PermissionDeliveryOption.DELIVERY_POINT_LIST,
    permissions: ['domi.points.list'],
    comparator: ComparatorEnum.EXACT,
  },
  { code: 'P102', option: PermissionDeliveryOption.DELIVERY_POINT_FILTER, permissions: ['domi.point.filter'] },
  { code: 'P103', option: PermissionDeliveryOption.DELIVERY_POINT_CREATE, permissions: ['domi.points.create'] },
  {
    code: 'P104',
    option: PermissionDeliveryOption.DELIVERY_POINT_EDIT,
    permissions: ['domi.points.update'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P105',
    option: PermissionDeliveryOption.DELIVERY_POINT_ACTIVATE_OR_INACTIVATE,
    permissions: ['domi.point.activateOrInactivate'],
  },
  { code: 'P106', option: PermissionDeliveryOption.DELIVERY_ORDER_LIST, permissions: ['domi.services.list'] },
  { code: 'P107', option: PermissionDeliveryOption.DELIVERY_ORDER_FILTER_POINT, permissions: ['domi.order.filterPoint'] },
  { code: 'P108', option: PermissionDeliveryOption.DELIVERY_ORDER_DETAIL, permissions: ['domi.services.view'] },
  { code: 'P109', option: PermissionDeliveryOption.DELIVERY_ORDER_SHOW_TOTAL_SERVICE, permissions: ['domi.order.showTotalService'] },
  {
    code: 'P110',
    option: PermissionDeliveryOption.DELIVERY_ORDER_CREATE,
    permissions: ['domi.services.create'],
    related: [PermissionDeliveryOption.DELIVERY_ORDER_HIDE_CREATE],
  },
  { code: 'PXXX', option: PermissionDeliveryOption.DELIVERY_ORDER_HIDE_CREATE, permissions: ['domi.order.hideCreate'], hideAction: true },
  { code: 'P111', option: PermissionDeliveryOption.DELIVERY_ORDER_SHOW_ORDER_TYPE, permissions: ['domi.order.showOrderType'] },
  { code: 'P112', option: PermissionDeliveryOption.DELIVERY_ORDER_EDIT_ACTION, permissions: ['domi.order.editAction'] },
  { code: 'P113', option: PermissionDeliveryOption.DELIVERY_ORDER_EDIT, permissions: ['domi.order.edit'] },
  { code: 'P114', option: PermissionDeliveryOption.DELIVERY_ORDER_DUPLICATE_ACTION, permissions: ['domi.order.duplicateAction'] },
  { code: 'P115', option: PermissionDeliveryOption.DELIVERY_ORDER_SHOW_EVIDENCE_ACTION, permissions: ['domi.services.view_evidence'] },
  { code: 'P116', option: PermissionDeliveryOption.DELIVERY_ORDER_RATE_ACTION, permissions: ['domi.order.rateAction'] },
  { code: 'P117', option: PermissionDeliveryOption.DELIVERY_ORDER_CANCEL_ACTION, permissions: ['domi.services.cancel'] },
  {
    code: 'P118',
    option: PermissionDeliveryOption.DELIVERY_ORDER_HIDE_ORDER_TYPE,
    permissions: ['domi.order.hideOrderType'],
    hideAction: true,
    related: [PermissionDeliveryOption.DELIVERY_ORDER_HIDE_ORDER_TYPE],
  },
  { code: 'P119', option: PermissionDeliveryOption.DELIVERY_ORDER_PROGRAM, permissions: ['domi.order.program'] },
  { code: 'P120', option: PermissionDeliveryOption.DELIVERY_ORDER_ADD_ROUND_TRIP, permissions: ['domi.order.addRoundTrip'] },
  { code: 'P121', option: PermissionDeliveryOption.DELIVERY_ORDER_ADD_ROUND_TRIP_121, permissions: ['domi'] },
  {
    code: 'P122',
    option: PermissionDeliveryOption.DELIVERY_ORDER_ADD_ADDRESS,
    permissions: ['domi.order.addAddress'],
    related: [PermissionDeliveryOption.DELIVERY_ORDER_HIDE_ADD_ADDRESS],
  },
  {
    code: 'P123',
    option: PermissionDeliveryOption.DELIVERY_ORDER_HIDE_ADD_ADDRESS,
    permissions: ['domi.order.hideAddAddress'],
    hideAction: true,
  },
  { code: 'P124', option: PermissionDeliveryOption.DELIVERY_ORDER_ADD_TRANSFER, permissions: ['domi.order.addTransfer'] },
  {
    code: 'P125',
    option: PermissionDeliveryOption.DELIVERY_ORDER_HIDE_GEOREFERENCER,
    permissions: ['domi.order.hideSuggestPoints'],
    hideAction: true,
  },
  {
    code: 'P126',
    option: PermissionDeliveryOption.DELIVERY_ORDER_SHOW_GEOREFERENCER,
    permissions: ['domi.services.suggest_points'],
    related: [PermissionDeliveryOption.DELIVERY_ORDER_HIDE_GEOREFERENCER],
  },
  { code: 'P127', option: PermissionDeliveryOption.DELIVERY_ORDER_DELETE, permissions: ['domi.order.delete'] },
  {
    code: 'P128',
    option: PermissionDeliveryOption.DELIVERY_ORDER_UNLIMITED_DECLARED_VALUE,
    permissions: ['domi.services.unlimitedDeclaredValue'],
  },
  {
    code: 'P428',
    option: PermissionDeliveryOption.DELIVERY_ORDER_SHOW_NEW_SERVICES,
    permissions: ['domi.order.showNewServices'],
  },
  { code: 'PXXX', option: PermissionDeliveryOption.DELIVERY_ORDER_VIEW_TRACK, permissions: ['domi.services.view_track'] },
  { code: 'PXXX', option: PermissionDeliveryOption.DELIVERY_ORDER_REMOVE_CHAT, permissions: ['domi.services.remove_chat'] },
];
